import * as React from 'react';
import { Platform } from 'react-native';
import {
    ArrowRightIcon,
    FruitfulCustomIcon,
    Icon,
    InstitutionLogo,
    View,
    XStack,
} from 'smoothie';

import type { BankAccountDisplayDetail } from '../../../types/BankAccount';
import { TransactionDcSign } from '../../../types/Transactions';

interface LegacyTransactionIconProps {
    dcSign: TransactionDcSign;
    account: BankAccountDisplayDetail;
    iconBorderRadius?: number;
}

export const LegacyTransactionIcons = ({
    dcSign,
    account,
    iconBorderRadius = 20,
}: LegacyTransactionIconProps) => {
    const { icon, color } = account;

    const externalAccountLogo = <InstitutionLogo size="lg" />;

    const accountLogo = (
        <FruitfulCustomIcon icon={icon} color={color} size="lg" />
    );

    let firstLogo: React.JSX.Element, secondLogo: React.JSX.Element;
    if (dcSign === TransactionDcSign.CREDIT) {
        firstLogo = externalAccountLogo;
        secondLogo = accountLogo;
    } else {
        firstLogo = accountLogo;
        secondLogo = externalAccountLogo;
    }

    const shadowStyle = Platform.select({
        ios: {
            shadowColor: 'rgba(0, 0, 0, 0.05)',
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowOpacity: 0.05,
            shadowRadius: 10,
        },
        android: {
            elevation: 5,
        },
    });

    return (
        <XStack style={{ ...shadowStyle }}>
            <View marginRight={-12} borderRadius={iconBorderRadius}>
                {firstLogo}
            </View>
            <View
                backgroundColor="$white"
                padding={8}
                borderRadius={100}
                borderWidth={1}
                borderColor="$gray100"
                alignSelf="center"
                zIndex={1}
            >
                <Icon icon={ArrowRightIcon} size={16} />
            </View>
            <View marginLeft={-12} borderRadius={iconBorderRadius}>
                {secondLogo}
            </View>
        </XStack>
    );
};
